/* tslint:disable */
/* eslint-disable */
/**
 * NetBroker instrumentum lekérdező API
 * NetBroker instrumentum lekérdező szolgáltatások.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: zsolt.szabo@ersteinvestment.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export * from './api';
export * from './configuration';
